<template>
<transition name="Defi3">
  <div class="Defi3">

    <div class="Defi3__container">
      <Assets v-if="slugIsIn(['defi3'])"/>
      <Controls v-if="slugIsIn(['defi3'])"/>
    </div>

    <Portrait v-if="slugIsIn(['31', '32', 'defi3', '33'])"/>
    <transition name="Defi3__end">
      <div
        v-if="completed && slugIsIn(['defi3'])"
        class="Btn Defi3__end"
        @click="next" v-html="trans('Global.btn.completed')" />
    </transition>

    <transition name="Defi3__hint">
      <div class="Defi3__hint" v-if="slugIsIn(['31', '32']) && ready">
        <img :src="require('./img/assets/important.png')"/>
        <div v-html="trans('sentence')" v-if="slugIsIn(['32'])"/>
        <div v-html="trans('observe')" v-if="slugIsIn(['31'])"/>
      </div>
    </transition>

    <transition name="Defi3__download">
      <div class="Defi3__download" :class="'is-'+ lang" @click="download()" v-if="!downloaded && slugIsIn(['33']) && $root.$agent.tablet == null"> 
        <img :src="require('./img/assets/download.png')"/>
        <div class="Defi3__txt">{{ trans('download') }}</div>
      </div>
    </transition>

  </div>
</transition>
</template>

<script>
import { Draggable } from 'gsap/all'
import { Categories } from './js/Categories.js'
import Controls from './components/Controls'
import Assets from './components/Assets'
import Portrait from './components/Portrait'
import TweenMax from 'gsap'
import domtoimage from 'dom-to-image'

var b64toBlob = require('b64-to-blob');

export default {
  name: 'Defi3',
  components: { Controls, Assets, Portrait },
  data: () => ({
    completed: false,
    ready: false,
    dropzone: null,
    dropped: [ null ],
    last: null,
    downloaded: false
  }),
  beforeDestroy() {
    // this.words = []
  },
  computed: {
    portrait() { return this.$store.getters['app/portrait'] },
    base_64() { return this.$store.getters['app/base_64'] },
  },
  watch: {
    'portrait': {
        immediate: true,
        deep: true,
        handler() {    
          this.$nextTick(()=>{
            if(this.portrait.backgrounds != null 
            && this.portrait.silhouettes != null)
              this.completed = true
            else 
              this.completed = false 
          })
        }
    },
    '$route': {
      immediate: true,
      handler() {
        this.ready = false
        this.$nextTick(()=>{
          TweenMax.delayedCall(1, ()=>{
            this.setBase64()
            this.ready = true
          })
        }) 
      }
    },
  },
  translations: {
    fr: {
      sentence: "Utilise le codex pour sélectionner  les éléments de personnalisation inspirés des œuvres. Laisse aller ton imagination et surprend Enki avec ta création !",
      observe: "Crée ton propre portrait : tu peux te représenter toi-même ou représenter quelqu’un d’autre.",
      portrait: "mon-portrait",
      download: "Télécharger"
    },
    en: {
      sentence: "Use the codex to select the customization options inspired by the artworks. Let your imagination run free and surprise</br>Enki with your creation!",
      observe: "Create your own portrait: you can portray yourself or portray someone else.",
      portrait: "my-portrait",
      download: "Download"
    },
  },
  mounted() {
    this.$memory = null
  },
  methods: {
    setBase64() {
      domtoimage.toPng(document.getElementById('my-node'), { quality: 0.95 })
      .then( (dataUrl)=> {
        var img = new Image()
            img.src = dataUrl
        document.getElementById('capture').appendChild(img)
        TweenMax.delayedCall(.1, ()=>{
          domtoimage.toPng(document.getElementById('capture'), { quality: 0.95, width: 326, height: 435 })
          .then( (dataUrl)=> {
            this.$store.commit('app/UPDATE_BASE_64', dataUrl)    
          })
        })
      })
    },
    download() {
      this.$store.commit('app/SET_AMBIANCE', 'selection')
      this.downloaded = true

      // const contentType = 'image/png'
      // const byteCharacters = atob(this.base_64.substr(`data:${contentType};base64,`.length))
      // const byteArrays = []
      // for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      //     const slice = byteCharacters.slice(offset, offset + 1024)
      //     const byteNumbers = new Array(slice.length)
      //     for (let i = 0; i < slice.length; i++) {
      //         byteNumbers[i] = slice.charCodeAt(i)
      //     }
      //     const byteArray = new Uint8Array(byteNumbers)
      //           byteArrays.push(byteArray)
      // }
      // const blob = new Blob(byteArrays, {type: contentType})
      // const blobUrl = URL.createObjectURL(blob)

      // window.open(blobUrl, '_blank');
      // return


      // base64ToBlob
      // 
      // var reader = new FileReader();
      // var out = new Blob([this.base_64], { type: 'application/pdf'});
      // reader.onload = function(e){
      //   window.location.href = reader.result;
      // }

      // window.alert(out)

      // TweenMax.delayedCall(4, ()=> {

      //   window.alert('x')
      //   reader.readAsDataURL(out)

      // })

      // console.log(this.base_64);

      // const isbContentType = 'text/plain'

      // var reader = new FileReader();
      // reader.onload = function(e) {
      //   console.log(reader.result);
      // };
      // reader.readAsDataURL(this.base_64);

  

      //   var reader = new FileReader();
      // reader.onload = function(e) {
      //    var bdata = btoa(reader.result);
      //    var datauri = 'data:' + isbContentType + ';base64,' + bdata;
      //    window.open(datauri);
      //    newWindow = setTimeout(function() {
      //        newWindow.document.title = isbFilename;
      //    }, 10);
      // };
      // reader.readAsBinaryString(this.base_64);

      // return

      let link = document.createElement('a')
          link.download = this.trans('portrait') +'.png'
          link.href = this.base_64
          link.click()

          // link.href = blobUrl
          // TweenMax.delayedCall(.5, ()=>{
          //   link.click()
          // })
    },
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Defi3
  position fixed
  top 0px
  left 0px
  right 0px
  bottom 0px
  transition opacity 1s, transform 1s
  &-enter
  &-leave-active
    opacity 0
    transform scale(.7)

  &__container 
    +max-screen-height(tablet-portrait)
      position absolute
      top 50%
      transform scale(.8)

  &__infos
    position absolute
    text-align center
    bottom 100%
    margin-bottom 5px
    width 100%
    &-author
      font-size 14px

  &__end
    transition opacity .5s, transform .5s
    &-enter
    &-leave-active
      opacity 0
      transform translateY(20px)

  &__cover
    width 60vw
    left 20vw
    top 110px
    bottom 200px
    position absolute
    background-size contain
    background-position center center
    background-repeat no-repeat

  &__download
    position absolute
    bottom 130px
    right 30px
    cursor pointer
    background red
    width 174px
    height 42px
    border-radius 24px
    background white
    color black
    transition opacity 1s, transform .5s
    transition-delay 1s
    display flex
    align-items center
    justify-content space-between
    font-size 12px 
    text-transform uppercase
    letter-spacing 0.2em
    font-weight 700

    &.is-en
      width 160px

    & img 
      width 42px

    &-enter
      opacity 0
      transform translateX(-50%)

    &-leave-active
      opacity 0
      transition opacity 0s
      transition-delay 0s

  &__txt 
    padding 0 22px 0 0

  &__hint
    position absolute
    min-width 400px
    max-width 600px
    background black
    padding 16px
    border-radius 16px
    left 50%
    transform translateX(-50%)
    margin-top 80px
    text-align center
    color white
    bottom 48px
    opacity 1
    transition opacity .75s
    transition-delay 1s
    &-enter
      transition-delay 1s
      opacity 0
    &-leave-active
      transition-delay 0s
      transition opacity .25s
      opacity 0

    +max-screen-height(tablet-portrait)
      font-size 16px
      line-height 22px
      padding 12px
      min-width 360px
      border-radius 8px

    & img 
      position absolute
      top -15px
      left -16px

      +max-screen-height(tablet-portrait)
        width 28px
        left -3px
        top -15px

</style>



// WEBPACK FOOTER //
// src/components/defis/Defi3.vue